import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { ContentMediaSignResponse, SignContentMediaBody } from './types';

/** Presigns an S3 PUT for an episode's replacement audio or video file. Studio admins only. */
export async function signContentMedia(artistId: string, contentId: string, body: SignContentMediaBody) {
  const url = `/web/studio/artists/${artistId}/content/${contentId}/media/sign`;

  const response = await api.executePostRequest<ObjectResponse<ContentMediaSignResponse>>(url, body);

  return response.data;
}
